<template>
  <div>
    <v-dialog
      max-width="860"
      content-class="question-modal"
      :value="value"
      @input="$emit('input', $event)"
      v-if="value"
    >
      <div class="question-modal__wrapper">
        <v-btn @click="close" color="white" class="close elevation-0" fab small>
          <v-icon color="primary">$close</v-icon>
        </v-btn>

        <div class="question-modal__title">Ask a Question!</div>
        <hr class="hr-yellow" />
        <v-form lazy-validation ref="form" @submit.prevent="submit">
          <div class="question-modal__indicator">* Required Information</div>
          <v-row>
            <v-col sm="6" cols="12">
              <v-text-field
                label="Name *"
                v-model="form.name"
                :rules="[validation.required]"
                validate-on-blur
              />
            </v-col>
            <v-col sm="6" cols="12">
              <v-text-field
                label="Location *"
                v-model="form.location"
                :rules="[validation.required]"
                validate-on-blur
              />
            </v-col>
          </v-row>
          <v-textarea
            counter="1500"
            placeholder="Share your question..."
            v-model="form.question"
            background-color="#EBEBEB"
          />
          <v-btn color="jude_lightred" type="submit">Submit</v-btn>
        </v-form>
      </div>
    </v-dialog>
  </div>
</template>

<script>
import formMixin from "@/mixins/form.mixin";

export default {
  name: "QuestionModal",
  extends: formMixin,
  props: {
    value: Boolean,
  },
  data() {
    return {
      form: {},
    };
  },
  methods: {
    close() {
      this.$emit("input", false);
    },
    async submit() {
      if (!this.validate()) {
        return this.$alert(
          "Form is invalid, please fill all required fields",
          "error"
        );
      }

      await this.$api.Question.create(this.form);

      this.form = {};
      this.$alert("Your question has been submitted successfully!", "success");
      this.close();
    },
  },
};
</script>

<style lang="scss">
.question-modal {
  position: relative;
  box-shadow: none !important;
  overflow: hidden;
  display: flex;
  margin: 0 !important;

  &__wrapper {
    border-radius: 10px;
    border: 4px solid $jude-darkred;
    background: #ffffff;
    padding: 32px 28px 44px;
  }

  &__title {
    font-weight: bold;
    font-size: 43px;
    line-height: 50px;
  }

  hr {
    margin: 22px 0 15px;
  }

  &__indicator {
    margin-top: 6px;
    text-align: right;
    font-size: 11px;
    line-height: 16px;
    opacity: 0.5;
  }

  textarea {
    padding: 8px 12px;
  }
}

@media screen and (max-width: 960px) {
}
</style>
